import { useEffect, useMemo } from 'react'
import { opt } from 'store/opt'
import { ColorSettings } from 'type/Options'

const DARK = matchMedia('(prefers-color-scheme: dark)')

function setProperty(name: string, value: string | null | undefined) {
  document.documentElement.style.setProperty(name, value || null)
}

function setPixelProperty(name: string, value: number | null | undefined) {
  document.documentElement.style.setProperty(name, value == null ? null : value + 'px')
}

function getColors(dark: boolean): ColorSettings {
  if (opt.sela) return {}
  if (dark) return opt.options.color_dark ?? {}
  return opt.options.color ?? {}
}

function applyDesign() {
  const dark = opt.theme === 'auto' ? DARK.matches : opt.theme === 'dark'
  const theme = dark ? 'dark' : 'light'
  const color = getColors(dark)
  const font = opt.tsum ? 15 : 14
  const radius = opt.tsum ? 10 : opt.sela ? 12 : opt.radius(4)
  const primary = opt.tsum ? '#F94F0D' : color.primary
  const { safeAreaTop, safeAreaBottom } = opt.options

  document.documentElement.setAttribute('data-theme', theme)
  setProperty('--ui-text-color', color.text)
  setProperty('--ui-primary-color', primary)
  setPixelProperty('--ui-font-size', font)
  setPixelProperty('--ui-border-radius', radius)
  setProperty('--ui-background-color', color.background)
  setProperty('--ui-background-color-soft', color.background_soft)
  setProperty('--ui-background-color-hover', color.background_hover)
  setProperty('--body-shape-color', color.body_shape_color)
  setProperty('--mini-background-color', color.collapse_button)
  setProperty('--mini-text-color', color.collapse_button_text)
  setPixelProperty('--safe-top', safeAreaTop)
  setPixelProperty('--safe-bottom', safeAreaBottom)
}

export function useDesign() {
  const auto = opt.theme === 'auto'

  useMemo(() => {
    applyDesign()
  }, [])

  useEffect(() => {
    if (!auto) return

    function listener() {
      applyDesign()
    }

    DARK.addEventListener('change', listener)
    return () => DARK.removeEventListener('change', listener)
  }, [auto])
}
